export default __webpack_public_path__ + "static/bubbles-f6269d20e37f1c1227d43caf3017a61a.mp4";